import Link from '@/components/Link';
import { LegalIndexPageQuery, LegalPagePathsQuery } from '@/graphql';
import LegalIndexPageQueryDocument from '@/graphql/queries/LegalIndexPage.gql';
import LegalPagePathsQueryDocument from '@/graphql/queries/LegalPagePaths.gql';
import { getStaticPageProps } from '@/lib/next';
import { notEmpty } from '@/lib/typescript-helpers';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import LegalTemplate from '@/templates/LegalTemplate';
import styled from 'styled-components';

const StyledHTMLContainer = styled.section`
  ${customTextSize(16, 24)};
  text-align: center;

  h1 {
    ${customTextSize(48, 54)};
    font-weight: ${FONT_WEIGHTS.SEMIBOLD};
    margin-bottom: ${remCalc(38)};
  }

  ul {
    li {
      + li {
        margin-top: 1rem;
      }
    }
  }

  a {
    border-bottom: 1px solid;
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(18, 26)};
  }
`;

const LegalIndex: PageTemplate<LegalIndexPageQuery & LegalPagePathsQuery> = ({ entries, entry }) => {
  return (
    <StyledHTMLContainer>
      <h1>{entry?.heading ?? ''}</h1>

      <ul>
        {entries?.filter(notEmpty).map((entry) => (
          <li key={entry?.id}>
            <Link href={entry?.uri!}>
              <a>{entry?.title}</a>
            </Link>
          </li>
        ))}
      </ul>
    </StyledHTMLContainer>
  );
};

LegalIndex.template = LegalTemplate;

export default LegalIndex;

export const getStaticProps = getStaticPageProps<{}, { slug: string[] }>('legal', async ({ client }) => {
  const { entry } = await client.request<LegalIndexPageQuery>(LegalIndexPageQueryDocument);
  const { entries } = await client.request<LegalPagePathsQuery>(LegalPagePathsQueryDocument);

  return {
    props: {
      entry,
      entries,
    },
  };
});
